import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import RenderPage from "./Login/Renderpage";
import HomePage from "./Login/HomePage";
import MeetingAuth from "./Login/MeetingAuth";
import Chat from "./Chat/Chat";
import Train from "./Chat/Train";
import LiveTrain from "./Chat/LiveTrain";
import TrainingRoom from "./Chat/TrainingRoom";
// import AgentRoom from "./Chat/AgentRoom";
import CreateRoom from "./Chat/CreateRoom";
import PageNotFound from "./Login/PageNotFound";
import ImageAnal from "./Image Analytics/ImageAnal";
import PrivateRoute from './PrivateRoute';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./index.css";
// Import the ChatbotPlugin
// import ChatbotPlugin from "absl-chatbot-plugin";

// Error boundary component to prevent crashing if there's an issue with ChatbotPlugin
// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     console.error("Error in component:", error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return null; // Render nothing if there's an error
//     }

//     return this.props.children;
//   }
// }

// Chatbot wrapper component
// const ChatbotWrapper = () => {
//   return (
//     <ErrorBoundary>
//       <ChatbotPlugin
//         title="Vaani Support"
//         primaryColor="#4a90e2"
//         position="bottom-right"
//         welcomeMessage="Hello! How can I help you today?"
//         apiEndpoint="http://127.0.0.1:5057/chat"

//         // Data source configuration
//         websiteName="https://www.arcturusbusiness.in"
//         dbConnection="mysql://root:@localhost:3306/vaaniai"
//         // dbConnection="mysql+pymysql://root:@localhost:3306/vaaniai"
//         dbTables={["users", "trainingmodule", "message_chat"]}
//         websiteScrapingEnabled={true}
//         websitePagesToScrape={["/", "/about-us", "/services", "/testimonials", "/blog", "/contact-us"]}
//         allowFileUpload={true}
//         fileTypes={[".pdf", ".jpg", ".png", ".docx", ".doc", ".csv", ".xls", ".sql", ".txt", "."]}

//         // Authentication
//         apiKey="koncnsjiyutywoihcbckasbcbs"

//         // UI configuration
//         supportedLanguages={["en", "hi"]}
//         defaultLanguage="en"
//         enableVoiceInput={true}
//         botIdentity="ArcturusAI"
//       />
//     </ErrorBoundary>
//   );
// };

// Main App component
const App = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <RenderPage />
              </PrivateRoute>
            }
          />

          {/* Protected routes */}
          <Route
            path="chat"
            element={
              <PrivateRoute>
                <Chat />
              </PrivateRoute>
            }
          />
          <Route
            path="train"
            element={
              <PrivateRoute>
                <Train />
              </PrivateRoute>
            }
          />
          <Route
            path="img_analysis"
            element={
              <PrivateRoute>
                <ImageAnal />
              </PrivateRoute>
            }
          />

          <Route
            path="render"
            element={
              <PrivateRoute>
                <RenderPage />
              </PrivateRoute>
            }
          />
          <Route
            path="home"
            element={
              <HomePage />
            }
          />

          <Route
            path="liveTrainingRoom"
            element={
              <LiveTrain />
            }
          />

          <Route
            path="livetraining/:meetingID"
            element={
              <TrainingRoom />
            }
          />

          {/* <Route
            path="agentTalkingRoom/:meetingID"
            element={
              <AgentRoom />
            }
          /> */}

          <Route path="/meeting/:meetingID" element={<MeetingAuth />} />
          <Route path="/CreateRoom" element={<CreateRoom />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>

      {/* Add the ChatbotPlugin wrapper outside of routes but inside BrowserRouter */}
      {/* <ChatbotWrapper /> */}
    </React.StrictMode>
  );
};

// Render the App
const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

// Report web vitals
reportWebVitals();